<template>
  <div class="reschedule-bottom-bar">
    <div class="reschedule-bottom-bar__inner">
      <div class="reschedule-bottom-bar__text">
        <div class="reschedule-bottom-bar__row">
          <span class="reschedule-bottom-bar__title">請選擇欲入住的日期及房型</span>
          <span class="reschedule-bottom-bar__hint">
            一天僅可選一間房間含不同房型，<span style="color: #ea6a2a">再次點擊房間</span>將取消已選擇房間
          </span>
        </div>
        <div class="reschedule-bottom-bar__sub">
          {{ selectedStayRange || '請選擇入住日期及房型' }}｜本訂單共
          <span style="color: #ea6a2a; font-size: large; font-weight: 500">{{ orderPetCount }}</span>
          隻寵物
        </div>
      </div>
      <el-button
        :disabled="disabled"
        :style="{ opacity: disabled ? 0.5 : 1 }"
        class="reschedule-bottom-bar__confirm-btn"
        @click="$emit('confirm')"
      >
        確認修改日期
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HotelRescheduleBottomBar',
  props: {
    selectedStayRange: {
      type: String,
      default: '',
    },
    orderPetCount: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style scoped lang="scss">
.reschedule-bottom-bar {
  flex-shrink: 0;
  width: 100%;
  height: 80px;
  background-color: #ffffff;
  border-top: 1px solid #e5e7eb;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px 0 48px;
  z-index: 5;
}

.reschedule-bottom-bar__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.reschedule-bottom-bar__text {
  display: flex;
  flex-direction: column;
  line-height: 1.8;
  flex: 1;
  min-width: 0;
  margin-right: 16px;
}

.reschedule-bottom-bar__row {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #000000;
}

.reschedule-bottom-bar__title {
  font-size: large;
  font-weight: 500;
  flex-shrink: 0;
}

.reschedule-bottom-bar__hint {
  font-size: 14px;
}

.reschedule-bottom-bar__sub {
  color: #6c6b6b;
}

.reschedule-bottom-bar__confirm-btn {
  background-color: #ea6a2a !important;
  color: #ffffff !important;
  border-radius: 8px;
  flex-shrink: 0;
  width: 240px;
  height: 50px;
  border: none;
}
</style>
